import React from "react";
import { Pagination as BootStrapPagination } from "react-bootstrap";

const getDisplayPages = (pages, page) => {
    let result = Array.from({ length: pages }, (_, i) => i);
    if (pages > 5) {
        let range = [page - 2, page + 2];
        while (range[0] < 0) {
            range = range.map(i => i + 1)
        }
        while (range[1] >= pages) {
            range = range.map(i => i - 1)
        }
        result = result.slice(range[0], range[1] + 1)
    }
    return result;
}

const Pagination = ({ pages, page, onPage }) => {

    if (pages < 2 || page === null || page === undefined) return null;

    return <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
        <BootStrapPagination style={{ margin: 0, marginBottom: '1rem' }}>
            <BootStrapPagination.First disabled={!page} onClick={() => onPage(0)} />
            <BootStrapPagination.Prev disabled={!page} onClick={() => onPage(page - 1)} />
            {getDisplayPages(pages, page).map(dPage => <BootStrapPagination.Item key={dPage} onClick={() => onPage(dPage)} active={dPage === page}>{dPage + 1}</BootStrapPagination.Item>)}
            <BootStrapPagination.Next disabled={page === pages - 1} onClick={() => onPage(page + 1)} />
            <BootStrapPagination.Last disabled={page === pages - 1} onClick={() => onPage(pages - 1)} />
        </BootStrapPagination>
    </div>
};

export default Pagination;